import React from 'react';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
import Qaqc from './component/Qaqc';
import SurfacePreparation from './component/SurfacePreparation';
import PaintingExecution from './component/PaintingExecution';

interface Props {
  statusRequest?: StatusInstance;
}

const QaqcDetail: React.FC<Props> = ({ statusRequest }) => {
  return (
    <div className="qaqc-detail">
      {statusRequest?.type === 'PAINTING' ? (
        <>
          <SurfacePreparation />
          <PaintingExecution />
        </>
      ) : (
        <Qaqc statusRequest={statusRequest} />
      )}
    </div>
  );
};

export default QaqcDetail;
